import { useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';
import { Page } from 'common/components/Page';
import {
    DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_CAPTION,
    DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_SLUG,
    DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_TITLE,
    IMPORTS_CAPTION,
    IMPORTS_SLUG,
    IMPORTS_TITLE } from 'common/constants/admin';
import { Roles } from 'common/constants/roles';
import { Routes, RoutesNameMap } from 'common/constants/routes';
import { usePalmButtonEvaluator } from 'common/hooks/usePalmButtonEvaluator';
import { useFeatures } from 'flagged';

import { SubpageNavButton } from '../../common/components/SubpageNavButton';

export function Admin() {
    const navigate = useNavigate();
    const { imports } = useFeatures();
    const shouldDisableImports = usePalmButtonEvaluator([Roles.Admin, Roles.UserManager]);

    const handleOpenAccountLinkingDashboard = () => {
        navigate(`/${Routes.Admin}/${DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_SLUG}`);
    };

    const handleOpenFileImports = () => {
        navigate(`/${Routes.Admin}/${IMPORTS_SLUG}`);
    };

    return (
        <Page
            title={RoutesNameMap.get(Routes.Admin)}
            header={(
                <Typography variant="h5" gutterBottom component="div" marginTop={'1rem'}>
                    {RoutesNameMap.get(Routes.Admin)}
                </Typography>
            )}
        >
            <main style={{ display: 'flex', justifyContent: 'flex-start', gap: '2rem' }}>
                <SubpageNavButton
                    title={DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_TITLE}
                    buttonCaption={DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_CAPTION}
                    onClick={handleOpenAccountLinkingDashboard}
                />
                {imports && <SubpageNavButton
                    title={IMPORTS_TITLE}
                    buttonCaption={IMPORTS_CAPTION}
                    onClick={handleOpenFileImports}
                    disable={shouldDisableImports}
                />
                }
            </main>
        </Page>
    );
}
